import Image from 'next/image'
import Link from 'next/link'
import Icon from './Icons'
import { useRouter } from 'next/router'
import { getUrlPrefix } from '@/helpers/UrlHelper'

import { useElementClick } from '@/hooks/HTMLElementClickHook'

import { DesktopLogo, MobileLogo } from './Topbar.styles'
import { Wrapper, MenuContainer, LeftLink, RightLink, Logo, VirginLogo } from './MinimalTopbar.styles'

import { useContext } from 'react'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { useTheme } from 'styled-components'

const MinimalTopbar = () => {
  const router = useRouter()
  const theme = useTheme()
  const { lang } = router.query

  const linkClick = useElementClick('Link')

  const DefaultProperties = useContext(DefaultPropertiesContext)
  const agentHandlerKey = DefaultProperties?.agentConfiguration.handlerKey
  const baseUrl = getUrlPrefix(DefaultProperties?.agentConfiguration?.handlerKey)

  return (
    <Wrapper>
      <MenuContainer>
        <Link
          href={`/${lang}`}
          data-testid={'HomeIconLink'}
          onClick={(event) => linkClick({ location: `TopBar | Home Icon`, event })}
        >
          <LeftLink>
            <Icon name="arrowCircleLeft" />
            Home
          </LeftLink>
        </Link>
        <Logo>
          <Link href={`${baseUrl}/${lang}`} onClick={(event) => linkClick({ location: `TopBar | ExOz logo`, event })}>
            <DesktopLogo>
              <Image src={theme?.logo?.image ? theme.logo.image : `${baseUrl}/logos/exoz-logo-light.svg`} alt="Experience Oz" width={137} height={32} />
            </DesktopLogo>
            <MobileLogo>
              <Image src={theme?.logo?.image ? theme.logo.image : `${baseUrl}/logos/exoz-logo-light-short.svg`} alt="Experience Oz" width={55} height={24} />
            </MobileLogo>
          </Link>
        </Logo>
        {agentHandlerKey == 'virgin' && (
          <VirginLogo>
            <Image
              src={`${baseUrl}/logos/velocity-virgin-logo-light.svg`}
              alt="Virgin Australia"
              width={202}
              height={42}
            />
          </VirginLogo>
        )}
        {/* todo: need info for this first
				<RightLink>
          <Icon name="info" />
          Need help?
        </RightLink> */}
      </MenuContainer>
    </Wrapper>
  )
}

export default MinimalTopbar
